import { render, staticRenderFns } from "./PhotoUploadButton.vue?vue&type=template&id=dbab8d3c&scoped=true&"
import script from "./PhotoUploadButton.vue?vue&type=script&lang=js&"
export * from "./PhotoUploadButton.vue?vue&type=script&lang=js&"
import style0 from "./PhotoUploadButton.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PhotoUploadButton.vue?vue&type=style&index=1&id=dbab8d3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbab8d3c",
  null
  
)

export default component.exports